module.exports = __webpack_public_path__ + "static/media/desktop.0f4a8a1d.svg";